import { Component, OnInit, NgZone } from '@angular/core';
import { CommonNotificationService } from '../../services/common-notification.service';
import { BaseWidgetComponent } from '../base-widget.component';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent extends BaseWidgetComponent {

  isSpinnerHidden: boolean = true;
  constructor(private commonNotificationService: CommonNotificationService, private zone: NgZone) {
    super();
    let counter: number = 0;
    this.commonNotificationService.$loadingSpinnerSource.takeUntil(this.emitUnsubscribe).subscribe(
      (flag: boolean) => {
        zone.run(() => {
          if (flag) {
            counter++;
            this.isSpinnerHidden = false;
          }
          else {
            counter = (counter > 0) ? (counter - 1) : 0;
            this.isSpinnerHidden = (counter === 0);
          }
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/widgets/loading-spinner/loading-spinner.component.ts